export const getQueryParamValue = key => {
  if (typeof window === 'undefined') {
    return null;
  }
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get(key);
};
export const hasQueryParam = key => {
  const queryParamValue = getQueryParamValue(key);
  return queryParamValue === 'true';
};
//# sourceMappingURL=url-utils.js.map